var getSafeframeAssetsPath = function getSafeframeAssetsPath() {
  if ("2220dbb6f46514189479d5714cd35392c36e3037") {
    return "".concat("https://safeinator.reamedia.com.au", "/").concat("2220dbb6f46514189479d5714cd35392c36e3037");
  }

  return "https://safeinator.reamedia.com.au";
};

export var SAFEFRAME_ASSETS_PATH = getSafeframeAssetsPath();
export var PREBID_IFRAME_ORIGIN = "https://safeinator.reamedia.com.au";
//# sourceMappingURL=rui-env-variables.js.map